import {Component, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import {CmlTemplateRowComponent} from '../cml-template-row/cml-template-row.component';
import {HighlightPipe} from '../highlight.pipe';
import {TplSource, TplConfig, TemplateGroup, colorToVar, allSelected, someSelected} from '../cml-types';

@Component({
  selector: 'cml-group-section',
  standalone: true,
  imports: [CmlTemplateRowComponent, HighlightPipe],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="cml-group" [class.cml-group--default]="group.isDefault" [class.cml-group--collapsed]="!expanded"
         [style.border-left-color]="group.isDefault ? null : colorToVar(group.color)">
      <div class="cml-group__header" (click)="toggleExpand.emit()">
        <div class="contcheckGrp">
          <input type="checkbox" class="inCheckGrp" [id]="'grp' + eventId + (group._id || 'default')"
                 [checked]="isAllChecked()"
                 [indeterminate]="isIndeterminate()"
                 (click)="$event.stopPropagation()"
                 (change)="toggleAll.emit(group.templates)">
          <label class="labCheckGrp" [for]="'grp' + eventId + (group._id || 'default')" (click)="$event.stopPropagation()">
            <i class="fas fa-check icCheckGrp"></i>
          </label>
        </div>
        <span class="cml-group__name" [innerHTML]="group.name | highlight:searchTerm"></span>
        <span class="cml-group__count">({{ group.templates.length }} tarif{{ group.templates.length > 1 ? 's' : '' }})</span>
        <i class="far fa-chevron-down cml-group__chevron"></i>
      </div>
      @if (expanded) {
        <div class="cml-group__body">
          @for (tpl of group.templates; track tpl._id; let idx = $index) {
            <cml-template-row
              [tpl]="tpl"
              [config]="configs[tpl._id]"
              [searchTerm]="searchTerm"
              (toggle)="tplToggle.emit($event)"
              (nfcChange)="tplNfcChange.emit($event)"
              (scanChange)="tplScanChange.emit($event)"
              (colorChange)="tplColorChange.emit($event)"
            />
          }
        </div>
      }
    </div>
  `
})
export class CmlGroupSectionComponent {
  @Input() group!: TemplateGroup;
  @Input() eventId!: string;
  @Input() expanded = true;
  @Input() configs: Record<string, TplConfig> = {};
  @Input() searchTerm = '';
  @Output() toggleExpand = new EventEmitter<void>();
  @Output() toggleAll = new EventEmitter<TplSource[]>();
  @Output() tplToggle = new EventEmitter<string>();
  @Output() tplNfcChange = new EventEmitter<{id: string; value: string}>();
  @Output() tplScanChange = new EventEmitter<{id: string; value: number}>();
  @Output() tplColorChange = new EventEmitter<{id: string; value: string}>();

  readonly colorToVar = colorToVar;

  private checkedCount(): number {
    return this.group.templates.filter(t => this.configs[t._id]?.checked).length;
  }

  isAllChecked(): boolean {
    return allSelected(this.checkedCount(), this.group.templates.length);
  }

  isIndeterminate(): boolean {
    return someSelected(this.checkedCount(), this.group.templates.length);
  }
}
